import type { CheckItem } from '../types';
import { emptyCheckItemMedia } from '../types';
import {
  formatChessGameItemHeadline,
  parseChessPgnHeaders,
  type ChessPlayerColor,
} from './chessPgnMeta';

/** Multiline item body: headline, analysis, then PGN at the end. */
export function buildChessGameJournalItemText(opts: {
  headline: string;
  analysis: string;
  pgn: string;
}): string {
  const parts = [opts.headline.trim(), opts.analysis.trim(), opts.pgn.trim()].filter(Boolean);
  return parts.join('\n\n');
}

export function buildChessGameJournalItem(opts: {
  pgn: string;
  analysis: string;
  playerColor: ChessPlayerColor | null;
  fallbackDateIso?: string;
  /** When set (e.g. Lichess summary), used instead of PGN-derived headline. */
  headline?: string;
}): CheckItem {
  const meta = parseChessPgnHeaders(opts.pgn);
  const headline =
    opts.headline?.trim() ||
    formatChessGameItemHeadline(meta, opts.playerColor, opts.fallbackDateIso);
  const text = buildChessGameJournalItemText({
    headline,
    analysis: opts.analysis,
    pgn: opts.pgn,
  });
  return {
    raw: '',
    text,
    date: '',
    state: 'open',
    ...emptyCheckItemMedia(),
  };
}
